export class ListPeticionEmbebido{
    public sesion_id_ses:String;
    public codCliente: string;
}